import React, { useEffect, useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import {useHistory, useParams, } from "react-router-dom";
import ImpersonateLoginPage from "./impersonate-login.page";
import {logout, setSession} from "../../../admin/redux";
import authApi from "../../../../app/api/authentication";
import {DASHBOARD} from "../../../dashboard/constants";
import {MOD_ADMIN} from "../../../../app/config/route";
import {getApiLang} from "../../../../app/feature/constants";
import {LOGOUT} from "../../config/public.route";

function ImpersonateLoginContainer() {
  const history = useHistory();
  const lang = useSelector(state => state.constant.languages)
  const { token } = useParams();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  useEffect(() => {
    const login = async () => {
      if (token) {
        try {
          const result = await authApi.impersonateLogin({
            token,
          });

          const { data: response } = result;
          if (response.success) {
            const sessionId = localStorage.getItem('session_id')
            const sessionExpiration = localStorage.getItem('session_expiration')

            if (sessionId || sessionExpiration) {
              await dispatch(logout({
                sessionId,
                sessionExpiration
              }));
            }

            localStorage.clear();
            localStorage.setItem('session_id', response.data.session_id);
            localStorage.setItem('session_expiration', response.data.session_expiration);
            await dispatch(setSession(response.data));
            history.push(`${MOD_ADMIN}/${DASHBOARD}`);
          }
          else {
            setError(getApiLang(lang, response.code));
          }
        } catch (error) {
          setError(getApiLang(lang, error.code));
        }
      }
    };

    login();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleLogout = () => {
    window.location.href = LOGOUT
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <ImpersonateLoginPage
      lang={lang}
      error={error}
      handleLogout={handleLogout}
      handleReload={handleReload}
    />
  );
}

export default connect()(ImpersonateLoginContainer);
